import css from 'styled-jsx/css'

export const tracingTourStyles = css`
  .tracing-tour-container {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1rem;
  }
`